<template>
  <div class="enterpriseAndCommonality">
    <el-dialog
      width="600px"
      title="停用"
      :visible.sync="isDialogShow"
      :close-on-click-modal="false"
      show-close
    >
      <div class="AddSupplierA">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="contactsForm"
        >
          <div class="AddSupplierATitle">确定要停用该供应商？</div>
          <div class="AddSupplierAContent">
            <!-- <el-row>
              <el-col :span="20">
                <el-form-item
                  label="综合评定等级："
                  prop="dutyDeptLevel"
                  label-width="140px"
                >
                  <el-select
                    v-model="ruleForm.dutyDeptLevel"
                    filterable
                    default-first-option
                    placeholder="请选择"
                  >
                    <el-option label="优秀" value="3"></el-option>
                    <el-option label="良好" value="2"></el-option>
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col :span="24">
                <el-form-item label="停用意见：" label-width="140px"  prop="stopReason">
                  <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    v-model="ruleForm.stopReason"
                    maxlength="200"
                    size="medium"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div class="bottomBtn">
          <el-button type="primary" @click="submitBtn('ruleForm')"
            >保 存</el-button
          >
          <el-button type="info" @click="isDialogShow = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  updateSupplierStatus, //更新供应商审批启用状态
  saveMSupplierEvaluateInfo
} from "@/services/supplierMagServices";
export default {
  name: "stopBDialog",
  data() {
    return {
      isDialogShow: false, //弹窗是否可见
      RouteParam: {}, //存储路由跳转参数
      supplierId: 0, //总包合同ID
      dialogVisible: false, //预览图片是否异步
      dialogImageUrl: "", //预览图片的路径
      workPhone: "",
      legalPerson: "",

      ruleForm: {
        id: "", //id
        status:0, //停用
        stopReason: "", //stopReason
      },

      rules: {
        stopReason: [
          { required: true, message: "请输入停用意见", trigger: "blur" },
        ],
      },
      isShopNameBool: false,
    };
  },
  methods: {
    showDialog(Id) {
      this.ruleForm.id = Id;
      this.isDialogShow = true;
    },

    //提交
    submitBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
           updateSupplierStatus(this.ruleForm)
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("操作成功", "提示", {
                confirmButtonText: "确定",
              });
              this.$refs.ruleForm.clearValidate();
              this.ruleForm.legalPerson='';
              this.ruleForm.stopReason='';
                this.$emit("close");
                this.isDialogShow = false;
            } else if (res.code > 20000000) {
             this.$message.error(res.msg);
            } else {
              this.$message.error('系统异常');
            }
          })
          .catch((error) => {
            this.$message.error("网络请求失败");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.enterpriseAndCommonality {
  background-color: white;

  // height: 100%;
}
/deep/.el-table .cell {
  white-space: pre-line;
}
/deep/.el-dialog__body {
  padding: 10px 20px;
}

/deep/.el-popover {
  padding: 24px;
}

.AddSupplierA {
  width: 100%;
}
@media only screen and(max-width:1680px) {
  .AddSupplierA {
    width: 100%;
  }
}
.AddSupplierA {
  background: rgba(255, 255, 255, 1);
  .el-form-item {
    width: 100%;
  }
  /deep/.cell .el-form-item__content {
    margin-left: 10px !important;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }

  .el-checkbox {
    line-height: 40px;
  }

  .el-textarea {
    min-width: 0px !important;
  }
  .el-cascader {
    width: 100%;
  }

  .el-form-item__content {
    width: calc(100% - 110px);
    line-height: 20px;

    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
  }
  .bottomBtn {
    // border-top: 1px solid #e6e6e6;
    width: 90%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    margin-bottom: 20px;
  }
  .AddSupplierATitle {
    height: 44px;
    padding-left: 24px;
    box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
    border-radius: 2px 2px 0px 0px;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 44px;
    text-align: left;
  }
  .AddSupplierAContent {
    padding: 14px 8px;
  }
  /deep/.daterangePicker {
    width: 255px;
    height: 32px;
    .el-input__icon {
      display: flex;
      align-items: center;
    }
    .el-range-separator {
      display: flex;
      align-items: center;
    }
  }
}
</style>
